<template>
<div class="MarketingList">
    <div class="bgc box-shadow title">
        <div class="classes blod">运营数据</div>
        <el-select v-model="param.eventinnerid" placeholder="请输入关键词选择" filterable remote :disabled="flag"
                   reserve-keyword :remote-method="remoteMethod" :loading="loading" @change="handleSearch">
            <el-option v-for="(item,index) in activityList" :key="index" :label="item.title" :value="item.innerid">{{item.title}}</el-option>
        </el-select>
    </div>
    <div class="data-total">
        <div class="outbox box-shadow">
            <div class="box">
                <div class="box-img icon_global"></div>
                <div class="box-detail">
                    <div class="box-title">全局转化率</div>
                    <div class="box-data">{{item.wholechange}}</div>
                </div>
                <el-tooltip content="当前活动全局数据，指所有访客进入页面的平均转化率" placement="top">
                    <div>
                        <i class="tip el-icon-info"></i>
                    </div>
                </el-tooltip>
            </div>
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">订单总数（笔）</div>
                    <div class="box-data">{{item.ordercount}}</div>
                </div>
            </div>
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">用户总数（UV）</div>
                    <div class="box-data">{{item.usercount}}</div>
                </div>
            </div>
        </div>
        <div class="outbox box-shadow">
            <div class="box">
                <div class="box-img icon_section"></div>
                <div class="box-detail">
                    <div class="box-title">分销转化率</div>
                    <div class="box-data">{{item.disconversion}}</div>
                </div>
                <el-tooltip content="通过扫码进入活动页面的订单转化率" placement="top">
                    <div>
                        <i class="tip el-icon-info"></i>
                    </div>
                </el-tooltip>
            </div>
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">分销订单数（笔）</div>
                    <div class="box-data">{{item.makeordercount}}</div>
                </div>
            </div>
            <div class="box">
                <div class="box-detail">
                    <div class="box-title">分销访客数（UV）</div>
                    <div class="box-data">{{item.haveparentusercount}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="echarts-box">
        <div class="left">
            <div class="box">
                <div class="name">最高裂变层级</div>
                <div class="value">{{item.maxdislayer}}</div>
            </div>
            <div class="box">
                <div class="name">每层平均数</div>
                <div class="value">{{item.percountbylayer}}</div>
            </div>
        </div>
        <lineReport :lineDatas="lineDatas" class="lineDatas"></lineReport>
    </div>
</div>
</template>

<script>
import {getOperationalData, getSimpleDisEventPageList} from 'api/nationalDistribution'
import {mapGetters, mapActions} from 'vuex'
import LineReport from 'base/echarts/lineReport'
import $ from 'jquery'
export default {
    name: 'MarketingList',
    data() {
        return {
            activityList: [],
            scrollTop: 0,
            selectPage: {
                page: 1,
                pageSize: 10,
                pageCount: 1
            },
            loading: false,
            item: {
                disconversion: '--', // 分销转化率
                haveparentusercount: 0, // 分销访客数
                makeordercount: 0, // 分销订单数
                maxdislayer: 0, // 最高裂变层级
                ordercount: 0, // 订单总数（笔）
                percountbylayer: '--', // 每层平均数
                usercount: 0, // 用户总数（UV）
                wholechange: '--', // 全局转化率
                tierinfo: { // 折线图信息集合
                    xdata: [],
                    ydata: []
                }
            },
            lineDatas: {id: 'index', subText: '订单总数', xdata: [], data: []}
        }
    },
    props: ['param', 'flag'],
    mounted() {
        this._getDisEventPageList()
    },
    methods: {
        remoteMethod(query) {
            if (query !== '') {
                this.loading = true
                this.param.title = query
                this._getDisEventPageList()
            } else {
                this.activityList = []
            }
        },
        handleSearch() {
            this.setParams(this._.cloneDeep(this.param))
            this._getList()
        },
        _getDisEventPageList() {
            getSimpleDisEventPageList({
                data: Object.assign({}, {title: this.param.title}, this.selectPage),
                success: data => {
                    this.activityList = data.data.content
                    this.selectPage.pageCount = data.data.pageinfo.pageCount
                    let _this = this
                    this.$nextTick(() => {
                        $('.el-scrollbar__wrap').scroll(function () {
                            let scrollTop = Math.floor(this.scrollTop)
                            let clientHeight = this.clientHeight
                            let scrollHeight = Math.floor(this.scrollHeight)
                            if (scrollTop + clientHeight === scrollHeight && _this.scrollTop !== scrollTop) {
                                if (_this.selectPage.page < _this.selectPage.pageCount) {
                                    _this.scrollTop = this.scrollTop
                                    _this._getSimpleDisEventPageList()
                                }
                            }
                        })
                    })
                    if (this.activityList.length) {
                        this.param.eventinnerid = this.param.eventinnerid ? this.param.eventinnerid : this.activityList[0].innerid
                        this._getList()
                    }
                    this.loading = false
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.loading = false
                }
            })
        },
        _getSimpleDisEventPageList() {
            this.selectPage.page++
            getSimpleDisEventPageList({
                data: Object.assign({}, {title: this.param.title}, this.selectPage),
                success: data => {
                    this.activityList = this.activityList.concat(data.data.content)
                    this.selectPage.pageCount = data.data.pageinfo.pageCount
                    let _this = this
                    this.$nextTick(() => {
                        $('.el-scrollbar__wrap').scroll(function () {
                            let scrollTop = Math.floor(this.scrollTop)
                            let clientHeight = this.clientHeight
                            let scrollHeight = Math.floor(this.scrollHeight)
                            if (scrollTop + clientHeight === scrollHeight && _this.scrollTop !== scrollTop) {
                                if (_this.selectPage.page < _this.selectPage.pageCount) {
                                    _this.scrollTop = this.scrollTop
                                    _this._getSimpleDisEventPageList()
                                }
                            }
                        })
                    })
                    this.loading = false
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.loading = false
                }
            })
        },
        _getList() {
            getOperationalData({
                data: Object.assign({}, this.param),
                success: data => {
                    this.item = data.data
                    this.lineDatas.xdata = this.item.tierinfo.xdata
                    this.lineDatas.data.push({
                        title: '订单总数',
                        color: '#1989FA',
                        smooth: true,
                        symbol: 'circle',
                        list: this.item.tierinfo.ydata
                    })
                    this.loading = false
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.loading = false
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        LineReport
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.MarketingList {
    .title{
        @include flexBox(space-between);
        height: 60px;
        padding: 0 20px;
        .classes{
            margin-bottom: 0;
        }
        .el-input__icon{
            line-height: 1;
        }
    }
    .data-total{
        margin-top: 24px;
        @include flexBox(flex-start);
        .outbox{
            @include flexBox(flex-start);
            padding: 10px 0;
            flex-grow: 1;
            background: $bgcolor-white;
            flex-basis: 200px;
            .box{
                @include flexBox(flex-start);
                padding: 20px 0;
                height: 100px;
                box-sizing: border-box;
                flex-grow: 1;
                position: relative;
                .box-img{
                    width: 60px;
                    height: 60px;
                    margin-right: 20px;
                    margin-left: 30px;
                }
                .box-detail{
                    flex-grow: 1;
                    .box-title{
                        font-size: $font-12;
                    }
                    .box-data{
                        margin-top: 5px;
                        font-size: $font-30;
                        color: $tcolor-blue;
                    }
                }
                .el-tooltip{
                    position: absolute;
                    width: 14px;
                    height: 14px;
                    top: 10px;
                    right: 10px;
                }
            }
            .box+.box{
                padding-left: 60px;
            }
            .box:nth-child(1){
                border-right: 1px solid $line;
            }
        }
        .outbox+.outbox{
            margin-left: 40px;
        }
    }
    .lineDatas{
        background: $bgcolor-white;
        padding: 20px
    }
    .echarts-box{
        margin-top: 20px;
        @include flexBox(flex-start);
        background: #fff;
        .left{
            background: #fff;
            padding: 0px 100px 40px 20px;
            .box{
                .name{
                    font-size: 12px;
                    margin-bottom: 10px;
                }
                .value{
                    font-size: 24px;
                    color: $tcolor-blue;
                }
            }
            .box+.box{
                margin-top: 40px;
            }
        }
        .lineReport{
            flex-grow: 1;
        }
    }
}
</style>
